'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _pureGraph = require('pure-graph');

var _functional = require('utils/functional');

var _utils = require('utils/utils');

var names = ['The Family Dog', 'How to Get Windows 10', 'Дорийский контрапункт контрастных фактур: основные моменты', 'A Robotic Dog’s Mortality', 'Welcome!', 'Some Random Funny Project Name'];
/* injects from baggage-loader */

var getStubData = function getStubData() {
  return {
    // name: randomElement(names) + randomElement(names) + randomElement(names) + randomElement(names),
    name: (0, _utils.randomElement)(names),

    nodesData: {
      pragmatic: { x: 110, y: -120, color: '#D0F192', caption: 'Pragmatic thinking' },
      focus: { x: 400, y: -80, color: '#6D826C', caption: 'Manage Focus' },
      learn: { x: -160, y: -50, color: '#6D826C', caption: 'Learn deliberately' },
      debug: { x: 150, y: 0, color: '#6D826C', caption: 'Debug your mind' },
      'gain-exp': { x: -400, y: 50, color: '#2A363B', caption: 'Gain experience' },
      'right-mind': { x: -200, y: 120, color: '#2A363B', caption: 'Get in your right mind' },
      cognitive: {
        x: 120, y: 250, color: '#2A363B', caption: 'Cognitive biases, Cognitive biases, Cognitive biases,\n        biases Cognitive biases, Cognitive biases, Cognitive biases, biases'
      },
      hardware: { x: 360, y: 200, color: '#2A363B', caption: 'Hardware bugs' },
      person: { x: 500, y: 150, color: '#2A363B', caption: 'Personality tendencies' }
    },

    graph: (0, _functional.compose)((0, _pureGraph.addEdge)('0', 'pragmatic', 'focus'), (0, _pureGraph.addEdge)('1', 'pragmatic', 'learn'), (0, _pureGraph.addEdge)('2', 'pragmatic', 'debug'), (0, _pureGraph.addEdge)('3', 'learn', 'gain-exp'), (0, _pureGraph.addEdge)('4', 'learn', 'right-mind'), (0, _pureGraph.addEdge)('5', 'debug', 'cognitive'), (0, _pureGraph.addEdge)('6', 'debug', 'hardware'), (0, _pureGraph.addEdge)('7', 'debug', 'person'), (0, _pureGraph.addNode)('pragmatic'), (0, _pureGraph.addNode)('focus'), (0, _pureGraph.addNode)('learn'), (0, _pureGraph.addNode)('debug'), (0, _pureGraph.addNode)('gain-exp'), (0, _pureGraph.addNode)('right-mind'), (0, _pureGraph.addNode)('cognitive'), (0, _pureGraph.addNode)('hardware'), (0, _pureGraph.addNode)('person'))(_pureGraph.EMPTY_GRAPH)
  };
};

exports.default = getStubData;


//////////////////
// WEBPACK FOOTER
// ./app/reducers/projectStubbedData.js
// module id = 628
// module chunks = 1